exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1nu6LhB7uEJFg0S9MPPLWT{min-width:250px}html[dir] ._2A9e8Wn2vhseL9DsIKoOH4{margin-bottom:20px}._2AhhKf9Fj-xsHkM3JNf1ST{width:auto;max-width:100%;height:80px}", ""]);

// exports
exports.locals = {
	"altTextInput": "_1nu6LhB7uEJFg0S9MPPLWT",
	"imagePreviewContainer": "_2A9e8Wn2vhseL9DsIKoOH4",
	"imagePreview": "_2AhhKf9Fj-xsHkM3JNf1ST"
};